import { getAppConfig } from "config/configInitializer";

export const isInvestCompany = async (): Promise<boolean> => {
  const { company } = getAppConfig();
  return company.COMPANY_ID === 11;
};

export const isInternationalCompany = async (): Promise<boolean> => {
  const { company } = getAppConfig();
  return company.COMPANY_ID === 24;
};

export const isMalaysiaCompany = async (): Promise<boolean> => {
  const { company } = getAppConfig();
  return company.COMPANY_ID === 23;
};
